import React from 'react';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';

// One stored template row: a single language and version. The blank instance also seeds the
// create/upload windows, so it carries SelectedFile and the default language.
export default class TemplateVariantItem {
  constructor(item) {
    if (item === undefined) {
      this.TemplateId = '';
      this.Name = '';
      this.Description = '';
      this.Locale = 'en_US';
      this.Type = '';
      this.Version = '';
      this.IsLatestVersion = true;
      this.IsStringContent = false;
      this.IsActive = true;
      this.SelectedFile = null;
      return;
    }

    this.TemplateId = item.templateId;
    this.Name = item.name;
    this.Description = item.description;
    this.Locale = item.locale;
    this.Type = item.type;
    this.Version = item.version;
    this.IsLatestVersion = item.isLatestVersion;
    this.IsStringContent = item.isStringContent;
    this.IsActive = item.isActive;
    this.SelectedFile = null;
  }

  static displayedInList = 'TemplateId';

  static NameOfTheIdField() {
    return 'TemplateId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item) return `Template Variant - ${item.Name} ${item.Locale} v${item.Version}`;
    return 'Template Variant';
  }

  // A version is stored on top of the newest one, so an older version can be read and downloaded but
  // not written to. The content action only appears for a template kept as text — a spreadsheet or a
  // document has to be downloaded, edited in its own program and uploaded back.
  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: item.IsLatestVersion ? 'fa-solid fa-code' : 'fa-solid fa-eye',
            text: item.IsLatestVersion ? 'Edit Content' : 'View Content',
            onClick: () => TemplateVariantItem.editContentFunction(item),
            hide: !item.IsStringContent,
            tooltipText: item.IsLatestVersion
              ? 'Edit this text template and see how it looks'
              : 'Look at what this version stores',
          },
          {
            iconName: 'fa-solid fa-upload',
            text: 'Upload New Version',
            onClick: () => TemplateVariantItem.uploadFunction(item),
            disabled: !item.IsLatestVersion,
            tooltipText: item.IsLatestVersion
              ? 'Store the uploaded file as the next version of this language'
              : 'Only the newest version of a language can take a new version.',
          },
          {
            iconName: 'fa-solid fa-download',
            text: 'Download',
            onClick: () => TemplateVariantItem.downloadFunction(item),
            tooltipText: 'Download this version',
          },
        ]}
      />
    );
  }

  static editContentFunction = (item) => {
    alert('Empty function');
  };

  static uploadFunction = (item) => {
    alert('Empty function');
  };

  static downloadFunction = (item) => {
    alert('Empty function');
  };

  static FieldsToShowInDataTable() {
    return [
      { label: 'ID', orderById: 'TemplateId', data: 'TemplateId' },
      { label: 'Name', orderById: 'Name', data: 'Name' },
      { label: 'Description', orderById: 'Description', data: 'Description' },
      { label: 'Language', orderById: 'Locale', data: 'Locale' },
      { label: 'Version', orderById: 'Version', data: 'Version' },
      { label: 'Data Type', orderById: 'Type', data: 'Type' },
      {
        label: 'Active',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        type: FieldTypesEnum.Bool,
      },
      {
        label: ' ',
        orderById: 'TemplateId',
        data: TemplateVariantItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'TemplateId', label: 'ID' },
        { name: 'Name', label: 'Name' },
        { name: 'Description', label: 'Description' },
        { name: 'Locale', label: 'Language' },
        { name: 'Version', label: 'Version' },
        { name: 'Type', label: 'Data Type' },
      ],
    },
  ];
}
